// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZqBa","label":"styles_label__3XyTG"};